import React from 'react';

const CalculatorLayout = ({ children }) => {
    return (
        <section className="flex flex-col w-full gap-4 px-4 py-3 pb-6 mx-auto md:py-12 md:gap-10 lg:px-0 bg-fd-calculator-gradient">
            <div className="max-w-[976px] w-full mx-auto md:bg-primary-40 md:p-6 rounded-3xl border md:border-none overflow-hidden">
                <div className="flex flex-col items-center w-full gap-8 p-4 md:gap-12 md:p-12  bg-basicWhite rounded-2xl">
                    {children}
                </div>
            </div>
        </section>
    );
};

export default CalculatorLayout;
